"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTask_1 = require("./BaseTask");
/**
 * [[RunnableTask]] Task wrapper for any Promised-operation
 */


var RunnableTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(RunnableTask, _BaseTask_1$default);

  var _super = _createSuper(RunnableTask);

  function RunnableTask(logger, fn) {
    var _this;

    var taskName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'RunnableTask';

    _classCallCheck(this, RunnableTask);

    _this = _super.call(this, logger);
    _this.fn = fn;
    _this.taskName = taskName;
    return _this;
  }

  _createClass(RunnableTask, [{
    key: "run",
    value: function run() {
      return this.fn().then(function () {});
    }
  }]);

  return RunnableTask;
}(BaseTask_1.default);

exports.default = RunnableTask;